/*
 *   Lazysizes config
 *
 */
window.lazySizesConfig = Object.assign(window.lazySizesConfig || {}, {
    init: false
});
import lazySizes from 'lazysizes';
import 'lazysizes/plugins/bgset/ls.bgset';

export default lazySizes;


// WEBPACK FOOTER //
// ./src/js/lib/lazysizes.js